import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Tack för din bedömning!',
  text: 'Finns det något vi kan förbättra? Dela din åsikt med oss.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Din åsikt...'
      }
    ],
    submit: {
      label: 'Skicka'
    }
  }
};